module.exports = __webpack_public_path__ + "src/assets/img/page4/81b1fad8c5f24e37c34c650d6ee2a9c6.png";